/**
 * Active-section title, provided by `WorkspaceShell` from the nav section
 * label. `PageShell` falls back to it for the card header heading (the
 * experiment AppShell shows the page title there), so pages only pass an
 * explicit `title` when they need something richer.
 */

import { createContext, useContext } from "react";

export const SectionTitleContext = createContext<string>("");

export function useSectionTitle(): string {
  return useContext(SectionTitleContext);
}
